import * as t from 'io-ts';
import { DateFromISOString } from 'io-ts-types';
const ConsentId = t.string;
const ConsentVersionId = t.string;
const ConsentIdAndVersionId = t.tuple([ConsentId, ConsentVersionId]);
export const CookieConsents = t.intersection([
    t.type({
        functional: t.boolean,
        analytics: t.boolean,
        marketing: t.boolean,
    }),
    t.partial({
        createdAt: DateFromISOString,
        interaction: t.keyof({
            allow: null,
            deny: null, // the user clicked "No, thanks" on the cookie banner
        }),
        updatedAt: t.partial({
            analytics: DateFromISOString,
            functional: DateFromISOString,
            marketing: DateFromISOString,
        }),
        versions: t.partial({
            analytics: ConsentIdAndVersionId,
            bundle: ConsentIdAndVersionId,
            functional: ConsentIdAndVersionId,
            marketing: ConsentIdAndVersionId,
            required: ConsentIdAndVersionId,
        }),
    }),
]);
